import { Link } from "react-router-dom";
import { Camera, MapPin, CreditCard, UserCheck, Star, BadgePoundSterling, ArrowRight } from "lucide-react";

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-12">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#8DE038] mb-3">/ How it works</div>
        <h1 className="font-display uppercase tracking-tighter text-5xl md:text-7xl text-[#F0F4F1] max-w-4xl">
          Garden services, <span className="text-[#8DE038]">decoded.</span>
        </h1>
        <p className="mt-6 max-w-3xl text-lg text-[#9CAEA3] leading-relaxed">Green Connect is a marketplace. Customers post jobs. Vetted contractors accept them. We take a small platform fee at booking — everything else is paid direct to your pro on the day.</p>
      </section>

      <section className="section-pad bg-[#050806]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="font-display uppercase tracking-[0.3em] text-xs text-[#8DE038] mb-3">/ Customers</div>
          <h2 className="font-display uppercase tracking-tighter text-3xl md:text-5xl text-[#F0F4F1] heading-accent">Book a pro in 60 seconds</h2>
          <div className="grid md:grid-cols-4 gap-3 mt-10">
            {[
              { i: Camera, t: "1. Upload photos", d: "Show the job. Helps the pro give an accurate estimate." },
              { i: MapPin, t: "2. Pick service + date", d: "Choose what you need and when. We match you to local pros." },
              { i: CreditCard, t: "3. Pay platform fee", d: "10% (min £5). Locks in your booking. Card via SumUp." },
              { i: Star, t: "4. Rate the work", d: "Pro turns up, does the job. Pay them on the day. Then rate." },
            ].map((s) => (
              <div key={s.t} className="gl-card p-7">
                <div className="w-12 h-12 bg-[#8DE038]/10 border border-[#8DE038]/40 flex items-center justify-center text-[#8DE038] mb-5"><s.i size={22}/></div>
                <div className="font-display uppercase tracking-wider text-lg text-[#F0F4F1]">{s.t}</div>
                <p className="text-[#9CAEA3] mt-2 text-sm leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
          <Link to="/book" className="btn-primary mt-10 text-xs">Book Now <ArrowRight size={14}/></Link>
        </div>
      </section>

      <section className="section-pad bg-[#0A0F0B]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="font-display uppercase tracking-[0.3em] text-xs text-[#8DE038] mb-3">/ Contractors</div>
          <h2 className="font-display uppercase tracking-tighter text-3xl md:text-5xl text-[#F0F4F1] heading-accent">Become a Green Connect pro</h2>
          <div className="grid md:grid-cols-4 gap-3 mt-10">
            {[
              { i: UserCheck, t: "1. Register", d: "Sign up free. Tell us your service area (postcode outcode)." },
              { i: Camera, t: "2. Upload ID & insurance", d: "Verify yourself. Our team reviews within 48h." },
              { i: BadgePoundSterling, t: "3. Get matched jobs", d: "We broadcast paid jobs in your area. First to accept wins." },
              { i: Star, t: "4. Build reputation", d: "Complete jobs, collect ratings. Top-rated pros get more work." },
            ].map((s) => (
              <div key={s.t} className="gl-card p-7">
                <div className="w-12 h-12 bg-[#8DE038]/10 border border-[#8DE038]/40 flex items-center justify-center text-[#8DE038] mb-5"><s.i size={22}/></div>
                <div className="font-display uppercase tracking-wider text-lg text-[#F0F4F1]">{s.t}</div>
                <p className="text-[#9CAEA3] mt-2 text-sm leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
          <Link to="/register?role=contractor" className="btn-primary mt-10 text-xs">Join as a Pro <ArrowRight size={14}/></Link>
        </div>
      </section>
    </div>
  );
}
